export default {
  content: {
    heading: {},
    subheading: {},
    content: {},
    items: [],
  },
};
